import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTokenInterceptor } from './interceptors/http.token.interceptor';
import { LoaderComponent } from './layout/loader/loader.component';
import { MaterialModule } from '../material.module';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { SsnMaskDirective } from './directives/ssn-mask.directive';
import { OnlylettersDirective } from './directives/onlyletters.directive';
import { OnlyLettersAndNumbersDirective } from './directives/only-letters-and-numbers.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { AuthComponent } from './components/auth/auth.component';
import { OnlyDecimalDirective } from './directives/only-decimal.directive';
import { ShowAuthDirective } from './directives/show-auth.directive';
import { FilterCharsDirective } from './directives/filter-chars.directive';
import { MatConfirmDialogComponent } from './components/mat-confirm-dialog/mat-confirm-dialog.component';
import { ChangeToUpperDirective } from './directives/change-to-upper.directive';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SsnFieldComponent } from './components/ssn-field/ssn-field.component';
import { ShowWindowComponent } from './components/show-window/show-window.component';
//import { BlockPasteDirective } from './directives/BlockPaste.directive';
import { IConfig,NgxMaskPipe } from 'ngx-mask';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ConfirmInactiveLogoutComponent } from './components/confirm-inactive-logout/confirm-inactive-logout.component';
import { AntigenSupplyDialogComponent } from './components/antigen-supply-dialog/antigen-supply-dialog.component';


@NgModule({ declarations: [
        LoaderComponent,
        PhoneMaskDirective,
        SsnMaskDirective,
        OnlylettersDirective,
        OnlyLettersAndNumbersDirective,
        OnlyNumbersDirective,
        AuthComponent,
        OnlyDecimalDirective,
        ShowAuthDirective,
        FilterCharsDirective,
        MatConfirmDialogComponent,
        ChangeToUpperDirective,
        SanitizeHtmlPipe,
        SsnFieldComponent,
        ShowWindowComponent
        //BlockPasteDirective       ,
        ,
        MessageBoxComponent,
        SafeHtmlPipe,
        ConfirmInactiveLogoutComponent,
        AntigenSupplyDialogComponent
    ],
    exports: [
        LoaderComponent,
        PhoneMaskDirective,
        SsnMaskDirective,
        OnlylettersDirective,
        OnlyLettersAndNumbersDirective,
        OnlyNumbersDirective,
        OnlyDecimalDirective,
        ShowAuthDirective,
        AuthComponent,
        FilterCharsDirective,
        ChangeToUpperDirective,
        SanitizeHtmlPipe,
        SsnFieldComponent,
        ShowWindowComponent,
        MessageBoxComponent,
        SafeHtmlPipe
        //BlockPasteDirective
    ], imports: [CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule], providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true }, provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule { }
